var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgShield = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.229,
    height: 34.324,
    viewBox: "0 0 29.229 34.324",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shield",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20431",
    "data-name": "Path 20431",
    d: "M14.615,34.324a.666.666,0,0,1-.127-.012A17.86,17.86,0,0,1,0,16.773V5.039A.67.67,0,0,1,.47,4.4L14.393.038A.727.727,0,0,1,14.615,0h0a.67.67,0,0,1,.221.038L28.759,4.4a.671.671,0,0,1,.47.64V16.773A17.861,17.861,0,0,1,14.741,34.312.666.666,0,0,1,14.615,34.324ZM1.341,5.532V16.773a16.542,16.542,0,0,0,13.274,16.2,16.542,16.542,0,0,0,13.274-16.2V5.532L14.615,1.373Zm0,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20432",
    "data-name": "Path 20432",
    d: "M65.7,82.844a.593.593,0,0,1-.145-.018,12.647,12.647,0,0,1-6.872-4.54A13.036,13.036,0,0,1,56,70.372V62.206a.609.609,0,0,1,.42-.582l9.106-2.9a.59.59,0,0,1,.358,0l9.106,2.9a.609.609,0,0,1,.42.582v8.166a13.039,13.039,0,0,1-1.467,6,.594.594,0,0,1-.81.253.616.616,0,0,1-.249-.825,11.793,11.793,0,0,0,1.327-5.43V62.654L65.7,59.94,57.2,62.654v7.718A11.56,11.56,0,0,0,65.7,81.6a11.217,11.217,0,0,0,3.851-1.874.592.592,0,0,1,.838.129.617.617,0,0,1-.127.853,12.4,12.4,0,0,1-4.417,2.114A.592.592,0,0,1,65.7,82.844Zm0,0",
    transform: "translate(-51.09 -53.546)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20433",
    "data-name": "Path 20433",
    d: "M128.088,184.683a.675.675,0,0,1-.479-.2l-4.539-4.539a.678.678,0,0,1,0-.959l2.3-2.3a.678.678,0,0,1,.959,0l1.759,1.759,4.221-4.222a.678.678,0,0,1,.959,0l2.3,2.3a.678.678,0,0,1,0,.959l-7,7A.676.676,0,0,1,128.088,184.683Zm-3.581-5.217,3.581,3.58L134.131,177l-1.342-1.342-4.221,4.222a.678.678,0,0,1-.959,0l-1.759-1.759Zm0,0",
    transform: "translate(-114.705 -162.192)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20434",
    "data-name": "Path 20434",
    d: "M312.1,372.855a.877.877,0,1,1,.62-.257A.881.881,0,0,1,312.1,372.855Zm0,0",
    transform: "translate(-290.664 -346.534)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShield, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shield.ff21a908.svg";
export { ForwardRef as ReactComponent };